import {reportPageView, reportEvent, reportFormSuccessAllWebSiteEvent} from '../utilities/analytics/selectAction';
import {AllowedList, ActionIsNotInList} from '../utilities/analytics/formConstants';

export default (store) => (next) => (action) => {
  try {
    if (action.payload?.page !== undefined) reportPageView(action.payload.page);
    if (action !== undefined) {
      reportEvent(action);

      if (AllowedList.indexOf(action.type) != ActionIsNotInList) {
        let _store = store.getState();
        reportFormSuccessAllWebSiteEvent(_store, action);
      }
    }
  } catch (e) {
    console.error(e);
  }

  return next(action);
};
